export default "__VITE_ASSET__CzrS9etL__"